import { GetProfileResponseDto } from '@shared/core/users'
import parsePhoneNumberFromString from 'libphonenumber-js'

type UserDto = Pick<GetProfileResponseDto, 'default_country_code'>

export function getDefaultCountryCode(user?: UserDto): string {
  // A per-browser "last used" country is deliberately not consulted: one foreign client would flip the default.
  if (user?.default_country_code) {
    return user.default_country_code.toLowerCase()
  }

  const browserLanguage = navigator.language || navigator.languages?.[0]
  if (browserLanguage && browserLanguage.includes('-')) {
    const inferredCountry = browserLanguage.split('-')[1]
    return inferredCountry.toLowerCase()
  }

  return 'us'
}

export function getPhoneAndCountryCode(
  phoneNumber: string | null | undefined,
  defaultCountry: string,
): { phone: string; country: string } {
  if (phoneNumber) {
    const normalized = phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`
    const parsed = parsePhoneNumberFromString(normalized)
    if (parsed?.isValid()) {
      return { phone: parsed.number, country: parsed.country.toLowerCase() }
    }
  }
  return { phone: (phoneNumber ?? '').replace(/\D/g, ''), country: defaultCountry }
}

export function getPlaceholder(country: string | undefined | null) {
  const placeholders = {
    us: '(555) 123-1234',
    fr: '06 12 34 56 78',
    ca: '(555) 123-1234',
    au: '(04) 1234 5678',
    gb: '07123 456789',
    es: '612 345 678',
    de: '0151 23456789',
    mx: '55 123 4567',
    it: '347 1234567',
    br: '(99) 988887777',
  }
  return placeholders[country?.toLowerCase()] || 'Phone number'
}
